"use strict";

$('.btn--aside').on('click', function () {
  $('.btn--aside').toggleClass('active');
  $('.nav--aside').toggleClass('active');
});

window.onclick = function (e) {
  if (!e.target.matches('.btn--aside')) {
    if ($('.btn--aside').hasClass('active')) {
      $('.btn--aside').toggleClass('active');
      $('.nav--aside').toggleClass('active');
    }
  }
};

$('.nav--news button').on('click', function () {
  $('.nav--news button').toggleClass('active');
  $('.nav--news ul').toggleClass('active');
});
$('.members-aside button').on('click', function () {
  var $this = $(this);
  $this.toggleClass('active');

  if ($this.hasClass('active')) {
    $this.children('p').text('Hide Menu');
  } else {
    $this.children('p').text('Show Menu');
  }

  $('.members-aside ul').toggleClass('active');
});
$(document).scroll(function () {
  var scrollPos = $(this).scrollTop();

  if (scrollPos >= 480) {
    $('#featured-caption').css({
      'opacity': 0
    });
  } else {
    $('#featured-caption').css({
      'opacity': 1
    });
  }
});
$('#navigation a').each(function () {
  this.href += '#navigation';
});
$('.subscribe-toggle').on('click touchstart', function (e) {
  // var offset = 0;
  // var speed = 1000;
  // var target = $(this.hash);
  // $("html,body").animate({
  //     scrollTop: target.offset().top - offset
  // }, speed);
  // // Scroll to a certain element
  // document.querySelector('.subscribe-form').scrollIntoView({
  //     behavior: 'smooth'
  // });
  $('.subscribe-form').toggleClass('active');
});
/*** Fancybox Settings ***/

$.fancybox.defaults.loop = true;
/*** Flickity ***/

$('.featured-slider').flickity({
  fade: true,
  wrapAround: true,
  autoPlay: 12000,
  arrowShape: 'M7.71816498,52 L43.2518815,87.0765985 L40.441824,89.9232767 L-2.77111667e-13,50.0017103 L40.4417608,10.0766609 L43.2519447,12.9232143 L7.72119407,48 L100,48 L100,52 L7.71816498,52 Z'
});
$('.testimonial-slider').flickity({
  wrapAround: true,
  pageDots: false,
  arrowShape: 'M7.71816498,52 L43.2518815,87.0765985 L40.441824,89.9232767 L-2.77111667e-13,50.0017103 L40.4417608,10.0766609 L43.2519447,12.9232143 L7.72119407,48 L100,48 L100,52 L7.71816498,52 Z'
});
/*** Smooth Scroll ***/

$('a[href*="#"]') // Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']'); // Does a scroll target exist?

    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  }
});
/*** AJAX Filter for Projects ***/

var partnerSlug = $('#partnersfilter').find(':selected').data('partner'),
    yearSlug = $('#yearfilter').find(':selected').data('year'),
    statusSlug = $('#statusfilter').find(':selected').data('status'),
    yearSlugArtistDirect = $('#yearfilterartistdirect').find(':selected').data('year'),
    statusSlugArtistDirect = $('#statusfilterartistdirect').find(':selected').data('status'),
    partnerQuery = '',
    yearQuery = '',
    statusQuery = '',
    searchQuery = '';

function addParams(partner, year, status) {
  if (partner === 'all' && year === 'all' && status === 'all') {
    searchQuery = '';
  } else {
    searchQuery = '?';
  }

  ;

  if (partner === 'all') {
    partnerQuery = '';
  } else {
    partnerQuery = "p_partner=".concat(partner);
  }

  ;

  if (year === 'all') {
    yearQuery = '';
  } else if (partner === 'all') {
    yearQuery = "p_year=".concat(year);
  } else {
    yearQuery = "&p_year=".concat(year);
  }

  ;

  if (status === 'all') {
    statusQuery = '';
  } else if (partner === 'all' && year === 'all') {
    statusQuery = "p_status=".concat(status);
  } else {
    statusQuery = "&p_status=".concat(status);
  }

  ;
}

function addParamsArtistDirect(year, status) {
  if (year === 'all' && status === 'all') {
    searchQuery = '';
  } else {
    searchQuery = '?';
  }

  ;

  if (year === 'all') {
    yearQuery = '';
  } else {
    yearQuery = "p_year=".concat(year);
  }

  ;

  if (status === 'all') {
    statusQuery = '';
  } else if (year === 'all') {
    statusQuery = "p_status=".concat(status);
  } else {
    statusQuery = "&p_status=".concat(status);
  }

  ;
}

jQuery(function ($) {
  $('#partnersfilter').change(function () {
    partnerSlug = $(this).find(':selected').data('partner');
    addParams(partnerSlug, yearSlug, statusSlug);
    $('#apply').click();
  });
  $('#yearfilter').change(function () {
    yearSlug = $(this).find(':selected').data('year');
    addParams(partnerSlug, yearSlug, statusSlug);
    $('#apply').click();
  });
  $('#statusfilter').change(function () {
    statusSlug = $(this).find(':selected').data('status');
    addParams(partnerSlug, yearSlug, statusSlug);
    $('#apply').click();
  });
  $('#yearfilterartistdirect').change(function () {
    yearSlugArtistDirect = $(this).find(':selected').data('year');
    addParamsArtistDirect(yearSlugArtistDirect, statusSlugArtistDirect);
    $('#apply').click();
  });
  $('#statusfilterartistdirect').change(function () {
    statusSlugArtistDirect = $(this).find(':selected').data('status');
    addParamsArtistDirect(yearSlugArtistDirect, statusSlugArtistDirect);
    $('#apply').click();
  });
  $('#filter').submit(function () {
    var filter = $('#filter');
    $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(),
      // form data
      type: filter.attr('method'),
      // POST
      success: function success(data) {
        $('#container').html(data); // insert data

        window.history.pushState('Details', 'Title', "/projects/".concat(searchQuery).concat(partnerQuery).concat(yearQuery).concat(statusQuery));
      }
    });
    return false;
  });
  $('#filter-artist-direct').submit(function () {
    var filter = $('#filter-artist-direct');
    $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(),
      // form data
      type: filter.attr('method'),
      // POST
      success: function success(data) {
        $('#container').html(data); // insert data

        window.history.pushState('Details', 'Title', "/projects/type/artist-direct/".concat(searchQuery).concat(yearQuery).concat(statusQuery));
      }
    });
    return false;
  });
  $('#filter-organization-led').submit(function () {
    var filter = $('#filter-organization-led');
    $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(),
      // form data
      type: filter.attr('method'),
      // POST
      success: function success(data) {
        $('#container').html(data); // insert data

        window.history.pushState('Details', 'Title', "/projects/type/organization-led/".concat(searchQuery).concat(partnerQuery).concat(yearQuery).concat(statusQuery));
      }
    });
    return false;
  });
});
/*** Members Directory - Modal ***/

var modal = $('.modal'),
    imageSource = '';

function modalOpen() {
  modal.addClass("modal--offstage"), setTimeout(function () {
    modal.addClass("modal--visible");
  }, 20);
}

function modalClose() {
  modal.removeClass("modal--visible"), setTimeout(function () {
    modal.removeClass("modal--offstage");
  }, 20);
}

$('.member-link').click(function (e) {
  var firstName = $(this).data('firstname'),
      lastName = $(this).data('lastname');
  imageSource = $(this).data('image');
  image = document.createElement('IMG');
  image.alt = "".concat(firstName, " ").concat(lastName);
  image.setAttribute('class', 'member-image');
  image.src = imageSource;

  if (imageSource) {
    $('.member-image-container').html(image);
    $('.member-image-container').addClass('has-image');
  } else {
    if ($('.member-image-container').hasClass('has-image')) {
      $('.member-image-container').removeClass('has-image');
    }

    $('.member-image-container').empty();
  }

  $('.member-image').attr('src', $(this).data('image'));
  $('.member-name').html("".concat(firstName, " ").concat(lastName));
  $('.member-title').html($(this).data('title'));
  $('.member-email').html($(this).data('email'));
  $('.member-email').attr('href', $(this).data('mailto'));
  $('.member-number').html($(this).data('phone'));
  $('.member-twitter').attr('href', $(this).data('twitter'));
  $('.member-facebook').attr('href', $(this).data('facebook'));
  modalOpen();
  e.preventDefault();
});
$('.modal').click(function () {
  modalClose();
});
$('body').keydown(function (e) {
  if (e.keyCode === 27 || e.keyCode === 27) {
    modalClose();
    e.preventDefault();
  }
});
/*** Edit Profile ***/

$('.profile-image-btn').click(function (e) {
  e.preventDefault();
  $('#acf-field_5c8144d96611f').click();
});